import Dropzone from 'dropzone';
export default {
  name: 'SchoolLogoUpload',
  props: {
    value: {
      type: Boolean,
      required: true
    },
    project: {
      type: Object,
      required: true
    }
  },
  mounted() {
    const self = this;
    this.uploader = new Dropzone(this.$refs.target, {
      url: this.url,
      // 8 hours
      timeout: 28800000,
      // 20 MB
      maxFilesize: 20,
      acceptedFiles: 'image/*',
      init() {
        this.on('sending', (file, xhr, formData) => {
          self.getCSRF(xhr);
        });
        this.on('success', (file, response, event) => {
          const xhr = event.target;
          if (xhr) {
            self.setCSRF(xhr);
          }
          self.$emit('success', response);
          self.$emit('input', false);
        });
        this.on('error', (file, error) => {
          self.$emit('failure', error);
        });
      }
    });

    // Create a Bootstrap modal.
    this.modal = jQuery(this.$refs.modal).modal({
      focus: true,
      show: false
    });
    this.modal.on('shown.bs.modal', this.shown.bind(this));
    this.modal.on('hidden.bs.modal', this.reset.bind(this));
  },
  watch: {
    show(value) {
      if (value) {
        this.modal.modal('show');
      } else {
        this.modal.modal('hide');
      }
    }
  },
  methods: {
    shown() {},
    reset() {
      if (this.uploader) {
        // Cancel all uploads and remove all files.
        this.uploader.removeAllFiles(true);
      }
      this.$emit('input', false);
    },
    getCSRF(xhr) {
      // Pass the CSRF token.
      xhr.setRequestHeader('X-CSRF-TOKEN', this.$store.getters['security/csrf']);
    },
    setCSRF(xhr) {
      // Store the newly generated CSRF token.
      this.$store.commit('security/csrf', xhr.getResponseHeader('X-CSRF-REFRESH'));
    }
  },
  computed: {
    url() {
      return `/forms/profile/${this.project.id}/logo`;
    },
    show() {
      return this.value;
    }
  }
};